
import AppConstants from '@/shared/app/model/AppConstants';
import Base from '@/shared/app/ui/Base.vue';
import Component from 'vue-class-component';

@Component
export default class DishGroup extends Base {
  get dishes() {
    return this.dataset('dishes');
  }

  get activeDishesIndexes() {
    let r: number[] = [];
    for (let i = 1; i <= AppConstants.MAX_DISHES; i += 1) {
      if (this.dishes[`dish${i}_enable`] === true) r.push(i);
    }

    // Offset: sauter N plats au début du dataset (alternance..etc)
    if (this.config.offsetDishes) {
      const offset = Number(this.config.offsetDishes);
      r = r.slice(offset);
    }

    if (this.config.maxDishes) {
      const max = Number(this.config.maxDishes);
      r = r.slice(0, max);
    }

    return r;
  }

  get component() {
    return this.config.component?.toString() || 'Dish';
  }
}
